<template>
  <div id="profile-general-module" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden body-module-height">
    <bds-scroll-area component-class="content-scroll-area">
      <div class="bg-white p-1" v-if="this.loaded">
        <!-- Img Row -->
        <div class="flex flex-wrap items-center mb-base">
          <div class="w-1/2">
            <!-- Image Container -->
            <bds-file-upload-box :attachment="userImage"
                                 file-extension="image/*"

                                 default-background="'https://homologbds3d.nyc3.digitaloceanspaces.com/avatar/blank_user.png'"
                                 @on-remove="removeFile"
                                 @uploadFile="uploadFile"/>
          </div>
        </div>

        <validation-observer ref="userDataGeneralRef" v-slot="{ invalid }" slim>
          <div class="w-full flex flex-wrap">
            <validation-provider name="displayName" rules="required" immediate v-slot="{ errors, invalid }" slim>
              <div class="w-full md:w-1/2 px-1">
                <bds-label :text="$t('pages.users.general.displayName')" :mandatory="invalid"/>
                <vs-input class="w-full md-base" v-model="dataGeneral.displayName" @change="changeData"></vs-input>
                <bds-error :text_error="errors[0]"/>
              </div>
            </validation-provider>

            <validation-provider vid="vidNickname" name="nickName" rules="required|alpha_num" v-slot="{ errors, invalid }" slim>
              <div class="w-full md:w-1/2 px-1">
                <bds-label :text="$t('pages.users.general.nickName')" :mandatory="invalid"/>
                <vs-input icon="alternate_email" class="w-full" v-model.trim="tempNickname" @change="changeNickName"
                          ref="nickname" id="nickname"/>
                <bds-error :text_error="errors[0]"/>
              </div>
            </validation-provider>

            <validation-provider name="fname" rules="required" immediate v-slot="{ errors, invalid }" slim>
              <div class="w-full md:w-1/2 px-1">
                <bds-label :text="$t('pages.users.general.fname')" :mandatory="invalid"/>
                <vs-input size="normal" class="w-full" v-model="dataGeneral.fname" @change="changeData"></vs-input>
                <bds-error :text_error="errors[0]"/>
              </div>
            </validation-provider>

            <validation-provider name="lname" rules="required" immediate v-slot="{ errors, invalid }" slim>
              <div class="w-full md:w-1/2 px-1">
                <bds-label :text="$t('pages.users.general.lname')" :mandatory="invalid"/>
                <vs-input class="w-full md-base" v-model="dataGeneral.lname" @change="changeData"></vs-input>
                <bds-error :text_error="errors[0]"/>
              </div>
            </validation-provider>

            <div class="mt-3 my-2 component-label">
              <span> {{ $t('pages.users.general.email') }} </span>
            </div>
            <vs-input class="w-full md-base" v-model="dataGeneral.email" :disabled="verifiedAccount" @change="changeData" />

            <vs-alert v-if="!verifiedAccount" icon-pack="feather" icon="icon-info" class="h-full my-4" color="warning">
            <span>
              {{ $t('pages.users.general.account_not_verified') }}
              <a href="#" class="hover:underline" @click.prevent="sendConfirmationEmail">
                {{ $t('pages.users.general.resend_confirmation_email') }}
              </a>
            </span>
            </vs-alert>

            <div class="w-full flex flex-wrap justify-end p-6">
              <vs-button class="mr-6" type="border" color="danger" @click="copyFromValue">
                {{ $t('buttons.cancel') }}
              </vs-button>
              <vs-button @click="submitData" :disabled="invalid"> {{ $t('buttons.save') }}</vs-button>
            </div>
          </div>
        </validation-observer>
      </div>
    </bds-scroll-area>
  </div>
</template>

<script>
import ProfileService from "@/services/Profile.service";
import UserService from "@/services/User.service";
import {DataGeneral} from "@/models/User.model";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {showErrorNotify, showErrorPopup, showSuccessNotify} from "@/helpers/functionsHelpers";
import AttachmentService from "@/services/Attachment.service";
import {CaseAttachment} from "@/models/cases/CaseAttachment.model";
import axios from "axios";

export default {
  name: 'user-general',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Object,
      default: () => new DataGeneral(),
    },

    verifiedAccount: {
      type: Boolean,
      default: true
    },
    userId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      dataGeneral: null,

      tempNickname: this.value.nickName ? this.value.nickName : null,

      userImage: null,
      bucketName: 'avatar',

      loaded: true,
    }
  },
  watch: {
    value() {
      //this.dataGeneral = DataGeneral.FromObj(this.value);
      if (this.value) {
        this.copyFromValue();
        this.loaded = true;
      }
    }
  },
  methods: {
    copyFromValue() {
      this.dataGeneral = DataGeneral.FromObj(this.value);
    },
    initAttachmentObject() {
      this.userImage = new CaseAttachment();
      this.userImage.bucketName = this.bucketName;
      this.userImage.attachmentType = 'general';
      this.userImage.stringId = `${this.userImage.bucketName}.${this.userImage.attachmentType}`;
      if (this.dataGeneral && this.dataGeneral.avatar) {
        this.userImage.url = this.dataGeneral.avatar;
        this.userImage.createdAt = Date.now();
      }
    },
    uploadFile(event_p) {
      let droppedFiles = event_p.event.target.files || event_p.event.dataTransfer.files;
      ([...droppedFiles]).forEach((file) => {
        const payload = {
          id: this.value.id,
          filename: file.name,
          filesize: file.size,
          boxname: this.bucketName,
          attachmentname: 'generic'
        };

        AttachmentService.createPostTempUrl(payload).then((responseCredentials) => {
          let form = new FormData();
          Object.keys(responseCredentials.s3.fields).forEach(key => {
            form.append(key, responseCredentials.s3.fields[key]);
          });
          form.append("file", file);
          axios.post(responseCredentials.s3.url, form).then((res) => {
            console.debug('S3 response...', res);
            this.dataGeneral.avatar = responseCredentials.url;
            this.initAttachmentObject();
            this.changeData();
          });
        }, (error) => {
          showErrorNotify(this, error);
        });
      });
    },
    removeFile() {
      this.dataGeneral.avatar = null;
      this.initAttachmentObject();
      this.changeData();
    },
    sendConfirmationEmail() {
      UserService.resendEmail(this.userId).then(() => {
        showSuccessNotify(this, this.$t('pages.users.resendEmailSuccess'));
      }, (error) => {
        showErrorPopup(this, error);
      });
    },
    validateGeneralData() {
      return this.$nextTick().then(() => {
        return this.$refs.userDataGeneralRef.validate().then((valid) => {
          return Promise.resolve(valid);
        });
      });
    },
    changeData() {
      this.validateGeneralData().then((valid) => {
        if (valid) {
          this.$emit('input', this.dataGeneral);
        }
      });
    },
    submitData() {
      this.$emit('submitData');
    },
    changeNickName() {
      this.$vs.loading({
        container: this.$refs.nickname.$el,
        scale: 0.45
      });

      ProfileService.checkNickname(this.tempNickname).then(() => {
        this.dataGeneral.nickName = this.tempNickname;
        this.changeData();
        this.$vs.loading.close(this.$refs.nickname.$el);
      }, () => {
        this.$refs.userDataGeneralRef.setErrors({
          vidNickname: this.$t('pages.users.general.invalidNickname'),
        });
        this.$vs.loading.close(this.$refs.nickname.$el);
      });
    },
  },
  created () {
    this.loaded = false;
  },
  mounted() {
    this.copyFromValue();
    this.initAttachmentObject();
    this.loaded = true;
  }
}
</script>

<style lang="scss">
  i.vs-icon.material-icons {
    font-size: 16px !important;
  }
</style>
